"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var alertingLocation_1 = require("../../models/alertingLocation");
var AlertingLocationsMixin = /** @class */ (function () {
    function AlertingLocationsMixin() {
    }
    AlertingLocationsMixin.prototype.createAlertingLocation = function (name, agencyId, boundary, unitIds, maxDistance, matchType, matchTypeCode, matchUnit, matchBox, matchPriority, matchTimeStart, matchTimeEnd, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, alertingLocation_1.AlertingLocation.parse));
        };
        var body = {
            name: name,
            agencyId: agencyId,
            boundary: boundary,
            unitIds: unitIds,
            maxDistance: maxDistance,
            matchType: matchType,
            matchTypeCode: matchTypeCode,
            matchUnit: matchUnit,
            matchBox: matchBox,
            matchPriority: matchPriority,
            matchTimeStart: matchTimeStart,
            matchTimeEnd: matchTimeEnd
        };
        this.http.post('/alerting-locations', null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AlertingLocationsMixin.prototype.getAlertingLocation = function (id, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, alertingLocation_1.AlertingLocation.parse));
        };
        this.http.get("/alerting-locations/" + id, null, this.unauthenticatedCallback(wrappedCallback));
    };
    AlertingLocationsMixin.prototype.editAlertingLocation = function (id, name, unitIds, maxDistance, matchType, matchTypeCode, matchUnit, matchBox, matchPriority, matchTimeStart, matchTimeEnd, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        var body = {
            name: name,
            unitIds: unitIds,
            maxDistance: maxDistance,
            matchType: matchType,
            matchTypeCode: matchTypeCode,
            matchUnit: matchUnit,
            matchBox: matchBox,
            matchPriority: matchPriority,
            matchTimeStart: matchTimeStart,
            matchTimeEnd: matchTimeEnd
        };
        this.http.put("/alerting-locations/" + id, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    AlertingLocationsMixin.prototype.deleteAlertingLocation = function (id, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.delete("/alerting-locations/" + id, null, this.unauthenticatedCallback(wrappedCallback));
    };
    AlertingLocationsMixin.prototype.getAgencyAlertingLocations = function (id, page, limit, query, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'locations', alertingLocation_1.AlertingLocation.parse); }));
        };
        var urlParams = { limit: limit, page: page };
        if (query != null) {
            urlParams.query = query;
        }
        this.http.get("/agencies/" + id + "/alerting-locations", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    return AlertingLocationsMixin;
}());
exports.default = AlertingLocationsMixin;
//# sourceMappingURL=AlertingLocationsMixin.js.map